import { Editor } from "shared/hubrise/editor"
import { ICategory, ICategoryOrProduct, IProduct, isCategory, isProduct } from "shared/hubrise/models"
import { Category } from "shared/hubrise/utils"

export const moveCategoryOrProduct = (
  editor: Editor,
  categoriesAndProducts: Array<ICategoryOrProduct>,
  categoryOrProduct: ICategoryOrProduct,
  newPosition: number,
): boolean => {
  const oldPosition = categoriesAndProducts.indexOf(categoryOrProduct)
  const newIndex = newPosition < oldPosition ? newPosition - 1 : newPosition
  // The following value is null if new position is 0
  const insertAfterItem = (categoriesAndProducts[newIndex] as ICategoryOrProduct | undefined) || null

  if (isProduct(categoryOrProduct)) {
    moveProduct(editor, categoryOrProduct, insertAfterItem)
  } else {
    moveCategory(editor, categoryOrProduct, insertAfterItem)
  }
  return true
}

const moveProduct = (editor: Editor, product: IProduct, insertAfterItem: ICategoryOrProduct | null): void => {
  if (insertAfterItem === null) return

  if (isProduct(insertAfterItem)) {
    editor.product.move(product, insertAfterItem.categoryId, insertAfterItem.id)
  } else {
    editor.product.move(product, insertAfterItem.id, null)
  }
}

const moveCategory = (editor: Editor, category: ICategory, insertAfterItem: ICategoryOrProduct | null): void => {
  if (insertAfterItem === null) {
    editor.category.move(category, null, null)
    return
  }

  if (isCategory(insertAfterItem)) {
    if (insertAfterItem.id !== category.id) editor.category.move(category, insertAfterItem.id, null)
  } else {
    const itemCategory = Category.byId(editor.catalog, insertAfterItem.categoryId)
    editor.category.move(category, itemCategory.parentId, itemCategory.id)
  }
}
